import { useContext } from "react";
import USUndoContext from "../contexts/USUndoProvider";

const useUSUndo = () => {
  return useContext(USUndoContext);
};

export default useUSUndo;
